<template>
<section>
    <b-overlay :show="showOverlay" rounded="lg" no-center="true">
        <template #overlay>
            <div class="text-center" style="margin-top: 300px;">
                <b-spinner v-if='csvUploadMessage === $t("csv_upload_loading")' style="width: 3rem; height: 3rem;margin-bottom:1rem" label="Large Spinner"></b-spinner>
                <p id="cancel-label">{{ csvUploadMessage }}</p>
                <b-button v-if='csvUploadMessage !== $t("csv_upload_loading")' class="btn green-rflocus" size="sm" @click="showOverlay = false">
                    OK
                </b-button>
            </div>
        </template>
        <b-table striped responsive borderless :fields="headers" :items="currentData" :busy="loading">
            <template v-slot:cell(delete)="data">
                    <b-form-checkbox  :key="data.index" v-model="selection" :value="data.item"></b-form-checkbox>
            </template>
            <template v-slot:cell(username)="data">
                {{data.value}}
            </template>
            <template v-slot:cell()="data">
                {{data.value}}
            </template>
        </b-table>

        <div class="w-100 d-flex justify-content-between">
            <div>
                <b-button class="btn green-rflocus mr-1" @click="addUser()">
                    <i class="fa fa-plus-square"></i> {{ $t("button.create") }}
                </b-button>
                <b-button class="btn green-rflocus mr-1" @click="setMenuManagement()">
                    <i class="fa fa-plus-square"></i> {{ $t("button.menu_management") }}
                </b-button>
                <b-button class="btn green-rflocus mr-1" @click="setMapManagement()">
                    <i class="fa fa-plus-square"></i> {{ $t("button.map_management") }}
                </b-button>
                <b-button class="btn green-rflocus mr-1" @click="setUserToEdit()">
                    <i class="fa fa-plus-square"></i> {{ $t("button.stock_update") }}
                </b-button>
                <b-button class="btn green-rflocus mr-1"  @keydown.enter="triggerFileInput">
                    <label for="file">
                            <i class="fa fa-cloud-upload m-r-5"></i>{{ $t("button.csv_upload") }}
                            
                    </label>
                </b-button>
                <input type="file" id="file" ref="file" accept=".csv, .xlsx, .xlsm" v-on:change="handleFileUpload(false)" hidden />

            </div>
            <div>
                <ButtonDelete @click="showDeleteUserAlert"></ButtonDelete>
            </div>

        </div>
        <b-pagination align="center" size="sm" :total-rows="pagination.totalRow" v-model="currentPage" :per-page="pagination.perPage"></b-pagination>


        <b-modal v-model="tenantModal" :title="$t(`user_manage.user_create`)" @ok="createTenant">

            <form>
                <b-form-group id="name-group" v-if="error_password !== ''">
                    <div class="attr_warning">{{error_password}}</div>
                </b-form-group>

                <b-form-group id="name-group" :label="$t(`user_manage.user_name`)" label-for="name-input" :invalid="!isNameValid">
                    <b-form-input id="name-input" v-model="newTenant.username" :class="{ 'is-invalid': !isNameValid }" autocomplete="off"></b-form-input>
                </b-form-group>

                <b-form-group id="password-group" :label="$t(`user_manage.password`)" label-for="password-input" :invalid="!isPasswordValid">
                    <b-form-input id="password-input" type="password" v-model="newTenant.password" :class="{ 'is-invalid': !isPasswordValid }" autocomplete="new-password" required></b-form-input>
                </b-form-group>

                <b-form-group id="confirm-password-group" :label="$t(`user_manage.confirm_password`)" label-for="confirm-password-input" :invalid="!isPasswordMatch">
                    <b-form-input id="confirm-password-input" type="password" v-model="newTenant.confirmPassword" :class="{ 'is-invalid': !isPasswordMatch }"></b-form-input>
                </b-form-group>

                <b-form-group id="remark-group" :label="$t(`user_manage.remarks`)" label-for="remark-input">
                    <b-form-input id="remark-input" v-model="newTenant.description"></b-form-input>
                </b-form-group>

            </form>
        </b-modal>

        <b-modal title="Delete Users" v-model="modalAlertDeleteUsers" size="s" @ok="deleteUser">
            <p>{{ $t('user_manage.confirm_delete_user', { users: selection.map((item) => item.username).join(", ")  }) }}</p>
        </b-modal>

        <b-modal title="Delete Users" v-model="modalAlertDeleteMainUsers" size="s" ok-only>
            <p>{{ $t('user_manage.delete_error', { tenantId: tenantId  }) }}</p>
        </b-modal>

        <b-modal v-model="userModal" size="s" @ok="updateUserFunction" :title="$t('user_manage.inventory_permission_management')">
            <div style="margin-top:15px" ><label style="font-weight:600">{{$t('location_edit')}}</label>
                <b-form-select :options="confirm_options" v-model='userToEdit.locationEditable' />
            </div>
            <div style="margin-top:15px"><label style="font-weight:600">{{$t('search_shipping')}}</label>
                <b-form-select :options="confirm_options" v-model='userToEdit.deleteStocks' />
            </div>
        </b-modal>
        <b-modal v-model="menuModal" size="s" @ok="updateUserMenuFunction" :title="$t(`user_manage.menu_management`)">
            <app-select-multi style="width:320px" :options="menuOptions" v-model="menuSelects"></app-select-multi>
        </b-modal>
        <b-modal v-model="mapModal" size="s" @ok="updateUserMapFunction" :title="$t(`user_manage.map_management`)">
            <app-select-multi style="width:320px" :options="warehouseOptions" v-model="warehouseSelects"></app-select-multi>
        </b-modal>

    </b-overlay>
</section>
</template>

<script>
// Components

import global from "../../Global.vue";
import * as mutations from "../../graphql/locus_mutations";
import * as queries from "../../graphql/locus_queries";
import {
    createUser
} from "../../graphql/mutations";

import AwsApi from "../../Api";

import {
    API,
    graphqlOperation,
    Storage
} from "aws-amplify";
import TheSelectMulti from "../../components/TheSelectMulti.vue"
import {
    onUpdateProcessJob
} from "../../graphql/locus_subscriptions";

export default {
    components: {
        'app-select-multi': TheSelectMulti,
    },
     watch: {
        currentPage: function () {
            this.updatePage();
        }
    },
    data() {
        return {
            tenantId: "",
            selection: [],
            headers: [{
                    key: "delete",
                    label: this.$t("select"),
                },
                {
                    key: "username",
                    label: this.$t("user_manage.user"),
                    thStyle: { minWidth: '200px' },
                },
                {
                    key: "menus",
                    label: this.$t("user_manage.menu"),
                    thStyle: { minWidth: '300px' },
                },
                {
                    key: "maps",
                    label: this.$t("user_manage.map"),
                    thStyle: { minWidth: '200px' },
                }

            ],
            allData: [],
            currentData: [],
            tenantModal: false,
            newTenant: {
                "username": "",
                "password": "",
                "confirmPassword": "",
                "description": ""
            },
            isNameValid: true,
            isPasswordValid: true,
            error_password: "",
            isPasswordMatch: true,
            loading: false,
            modalAlertDeleteUsers: false,
            modalAlertDeleteMainUsers: false,
            userModal: false,
            userToEdit: {
                locationEditable: false,
                deleteStocks: false
            },
            allMenuIds: [],
            stockMenuIds: [],
            error_confirm_password:this.$t("user_manage.password_mismatch"),
            mapModal: false,
            warehouseOptions: [],
            warehouseSelects: [],
            allMapIds: [],
            menuOptions: [],
            menuModal: false,
            menuSelects: [],
            reader: new FileReader(),
            showOverlay: false,
            csvUploadMessage: this.$t("csv_upload_loading"),
            uploadCSVTimer: null,
            updateCsvPath: "",
            userAuthManages: [],
            pagination: {
                totalRow: 0,
                perPage: 0
            },
            count: 30,
            currentPage: 1,
            confirm_options:[
                            { value: false, text: this.$t('option_no') },
                            { value: true, text: this.$t('option_yes') },
                            ]
        }
    },
    async mounted() {
        this.tenantId = sessionStorage.getItem(global.tenantId);
        await this.listHeader()
        this.warehouseOptions = []
        await this.listWarehouses()
        this.warehouseOptions.unshift({
            text: this.$t('all'),
            value: -1
        })
        await this.listUser()
        this.addSubscription()
        this.reader.addEventListener("load", function (event) {
            this.showOverlay = true
            this.csvUploadMessage = this.$t("csv_upload_loading")
            this.uploadCSV(this.reader.result).then((response) => {
                if (response === undefined) {
                    this.csvUploadMessage = this.$t("csv_upload_error")
                    return
                }
                var callApiTime = new Date().getTime()
                this.uploadCSVTimer = setInterval(() => {
                    if (new Date().getTime() - callApiTime >= global.timeout) {
                        clearInterval(this.uploadCSVTimer)
                        this.csvUploadMessage = this.$t("csv_upload_timeout")
                    }
                }, 1000)
                this.clearInput()
            })
        }.bind(this), false);
    },
    methods: {
        updatePage() {
            this.setData()
        },
        setData(){
            this.currentData = this.allData.slice((this.currentPage - 1) * this.count, this.currentPage * this.count)
        },
        async listWarehouses(nextTokenValue) {
            const response = await AwsApi.graphql({
                query: queries.listWarehouses,
                variables: {
                    tenantId: this.tenantId,
                    nextToken: nextTokenValue

                }
            }, this);
            if (response === undefined) {
                return
            }
            this.warehouseOptions = this.warehouseOptions.concat(response.data.listWarehouses.items.map((item) => {
                 const option = {
                    value: item.id,
                    text: `${item.name}`,
                }
                this.allMapIds.push(item.id)
                return option
            }));
            if (response.data.listWarehouses.nextToken !== null) {
                await this.listWarehouses(response.data.listWarehouses.nextToken)
            }
        },
        async listHeader() {
            const responseMenu = await API.graphql({
                query: queries.listMenus,
                variables: {
                    tenantId: this.tenantId
                }
            });
            if (responseMenu === undefined) {
                return
            }
            responseMenu.data.listMenus.items.forEach(item => {
                const option = {
                    value: item.id,
                    text: `${item.name}`,
                }
                this.menuOptions.push(option)
                this.allMenuIds.push(item.id)
                if (item.functionId === global.functionIdSTOCK ){
                    this.stockMenuIds.push(item.id)
                }
            })
        },
        
        async listUserAuthManages(nextTokenValue) {
            const response = await AwsApi.graphql({
                query: queries.listUserAuthManages,
                variables: {
                    tenantId: this.tenantId,
                    nextToken: nextTokenValue

                }
            }, this);
            if (response === undefined) {
                return
            }
            this.userAuthManages = this.userAuthManages.concat(response.data.listUserAuthManages.items);
            if (response.data.listUserAuthManages.nextToken !== null) {
                await this.listUserAuthManages(response.data.listUserAuthManages.nextToken)
            }
        },
        async listUser() {
            this.selection = []
            const createPro = []
            this.loading = true
            const response = await API.graphql({
                query: queries.listUsersInGroup,
                variables: {
                    group: this.tenantId
                }
            });
            if (response === undefined) {
                return
            }
            this.userAuthManages = []
            await this.listUserAuthManages()
            const sortUser = response.data.listUsersInGroup.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
            const mainUser = this.userAuthManages.filter(item => item.username === this.tenantId)
            if(mainUser.length === 0) {
                createPro.push(API.graphql({
                    query: mutations.createUserAuthManage,
                    variables: {
                        input: {
                            group: this.tenantId,
                            menuId: this.allMenuIds,
                            mapId: this.allMapIds,
                            tenantId: this.tenantId,
                            username: this.tenantId,
                        }
                    }
                }));
                Promise.all([...createPro]).then(() => this.listUser())
            } else {
                this.allData = sortUser.map(item => {
                    const currentUserAuth = this.userAuthManages.filter(j => j.username === item.username)
                    const element = {}
                    element["username"] = item.username
                    element["isUpdate"] = false
                    element.hasUserManage = false
                    if (currentUserAuth.length > 0) {
                        element["menus"] = this.geMenusName(currentUserAuth[0].menuId)
                        element["maps"] = this.getMapsName(currentUserAuth[0].mapId)
                        element["menuIds"] = currentUserAuth[0].menuId
                        element["mapIds"] = currentUserAuth[0].mapId
                        element["auth"] = currentUserAuth[0].auth
                        element.hasUserManage = true
                    }
                    
                    return element
                })
            }
            this.setData()
            this.pagination.totalRow = this.allData.length;
            this.pagination.perPage = this.count;
            this.loading = false
        },
        geMenusName(menuId){
            if(menuId === null) {
                return ""
            }
            return this.menuOptions.filter(item => menuId.includes(item.value))
            .map(item => item.text)
            .join(", ")
            
        },
        getMapsName(mapId){
            if(mapId === null) {
                return ""
            }
            return this.warehouseOptions.filter(item => mapId.includes(item.value))
            .map(item => item.text)
            .join(", ")

        },
        async createTenant(bvModalEvent) {
            bvModalEvent.preventDefault();

            if(this.newTenant.password != this.newTenant.confirmPassword){
                this.error_password = this.error_confirm_password
                return
            }

            var variables = {
                "groupname": sessionStorage.getItem(global.tenantId),
                "username": this.newTenant.username,
                "password": this.newTenant.password,
                "description": this.newTenant.description,
                "email": ""
            }

            const response = await API.graphql({
                query: createUser,
                variables: variables
            })
            if(response.data.createUser !== "OK") {
                this.error_password = response.data.createUser
            } else {
                this.tenantModal = false
                this.listUser()
            }

        },
        addUser() {
            this.error_password = ""
            this.tenantModal = true
            this.newTenant = {
                "username": "",
                "password": "",
                "confirmPassword": "",
                "description": ""
            }
        },
        showDeleteUserAlert() {
            const hasMain = this.selection.filter(item => item.username == this.tenantId)
            if(hasMain.length > 0){
                this.modalAlertDeleteMainUsers = true
            } else {
                this.modalAlertDeleteUsers = true
            }
        },
        deleteUser() {
            const selectedUsers = [...this.selection]
            AwsApi.checkSession(async () => {
                try {
                    for (const item of selectedUsers) {
                        if (item.hasUserManage) {
                            await API.graphql({
                                query: mutations.deleteUserAuthManage,
                                variables: {
                                    input: {
                                        tenantId: this.tenantId,
                                        username: item.username
                                    }
                                }
                            })
                        }

                        await API.graphql({
                            query: mutations.deleteUser,
                            variables: {
                                username: item.username
                            }
                        })
                    }
                } catch (error) {
                    console.error(error)
                } finally {
                    await this.listUser()
                }
            }, this)
        },
        changeItem(value, item) {
            item["isUpdate"] = true;
        },
        isFormValid() {
            if (!this.newTenant.username) {
                this.isNameValid = false
                return false
            }
            this.isNameValid = true

            const regex = /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/
            if (!regex.test(this.newTenant.password)) {
                this.isPasswordValid = false
                return false
            }
            this.isPasswordValid = true

            if (this.newTenant.password != this.newTenant.confirmPassword) {
                this.isPasswordMatch = false
                return false
            }
            this.isPasswordMatch = true

            return true

        },
        setUserToEdit(){
            if(this.selection.length > 0){
                if(this.selection[0].auth !== undefined && this.selection[0].auth !== null){
                    this.userToEdit = JSON.parse(this.selection[0].auth)
                }
                 this.userModal = true
            }
        },
        async updateUserFunction(){
            const updatePro = []
            var getUserAuthManage = await this.getUserAuthManage(this.selection[0])
            var input = {
                tenantId: this.tenantId,
                username: this.selection[0].username,
                auth: JSON.stringify(this.userToEdit)
            }
            
            if(getUserAuthManage !== null){
                updatePro.push(API.graphql({
                    query: mutations.updateUserAuthManage,
                    variables: {
                        input: input
                    }
                }))
            } else {
                updatePro.push(API.graphql({
                    query: mutations.createUserAuthManage,
                    variables: {
                        input: input
                    }
                }))
            }

            Promise.all([...updatePro]).then(() => this.listUser())
            
        },
        setMenuManagement(){
            if(this.selection.length > 0){
                this.menuSelects = this.selection[0].menuIds === undefined ? [] : this.selection[0].menuIds
                this.menuModal = true
            }
        },
        setMapManagement(){
            if(this.selection.length > 0){
                this.warehouseSelects = this.selection[0].mapIds === undefined ? [] : this.selection[0].mapIds
                this.mapModal = true
            }
        },
        async updateUserMapFunction(){
            const createPro = []
            const updatePro = []
            var getUserAuthManage = await this.getUserAuthManage(this.selection[0])
            var input = {
                    group: this.tenantId,
                    mapId: this.warehouseSelects,
                    tenantId: this.tenantId,
                    username: this.selection[0].username
                }
            if(this.warehouseSelects.includes(-1)) {
                var ids = JSON.parse(JSON.stringify(this.allMapIds))
                ids.unshift(-1)
                input = {
                    group: this.tenantId,
                    mapId: ids,
                    tenantId: this.tenantId,
                    username: this.selection[0].username
                }
            } else {
                input = {
                    group: this.tenantId,
                    mapId: this.warehouseSelects,
                    tenantId: this.tenantId,
                    username: this.selection[0].username
                }
            }
            if(getUserAuthManage !== null){
                updatePro.push(API.graphql({
                    query: mutations.updateUserAuthManage,
                    variables: {
                        input: input
                    }
                }))
            } else {
                updatePro.push(API.graphql({
                    query: mutations.createUserAuthManage,
                    variables: {
                        input: input
                    }
                }))
            }
            Promise.all([...updatePro, ...createPro]).then(() => this.listUser())
        },
        async updateUserMenuFunction(){
            const createPro = []
            const updatePro = []
            var getUserAuthManage = await this.getUserAuthManage(this.selection[0])
            var input = {
                    group: this.tenantId,
                    menuId: this.menuSelects,
                    tenantId: this.tenantId,
                    username: this.selection[0].username
                }
            if(getUserAuthManage !== null){
                updatePro.push(API.graphql({
                    query: mutations.updateUserAuthManage,
                    variables: {
                        input: input
                    }
                }))
            } else {
                updatePro.push(API.graphql({
                    query: mutations.createUserAuthManage,
                    variables: {
                        input: input
                    }
                }))
            }
            Promise.all([...updatePro, ...createPro]).then(() => this.listUser())
        },
        async getUserAuthManage(item){
            const response = await API.graphql({
                query: queries.getUserAuthManage,
                variables: {
                    tenantId: this.tenantId,
                    username: item.username,
                }
            });
            var getUserAuthManage = null
            if (response !== undefined && response.data.getUserAuthManage !== null) {
                getUserAuthManage = response.data.getUserAuthManage
            }
            return getUserAuthManage
        },
        triggerFileInput() {
            document.getElementById('file')?.click()
        },
        handleFileUpload() {
            this.file = this.$refs.file.files[0];
           
            /*
              Check to see if the file is not empty.
            */
            if (this.file) {
                if (/\.(csv)$/i.test(this.file.name)) {
                    this.reader.readAsText(this.file);
                }
                if (/\.(xlsx|xlsm)$/i.test(this.file.name)) {
                    this.reader.readAsArrayBuffer(this.file);
                }
            }

        },
        clearInput() {
            const input = this.$refs.file
            input.type = 'text'
            input.type = 'file'
        },
        async uploadCSV(csvStr) {

            //TODO
            if (/\.(xlsx)$/i.test(this.$refs.file.files[0].name)) {
                this.updateCsvPath = `${this.tenantId}/auth/${global.formatLongDate()}.xlsx`
                return await Storage.put(this.updateCsvPath, this.$refs.file.files[0]);
            } else if (/\.(xlsm)$/i.test(this.$refs.file.files[0].name)) {
                this.updateCsvPath = `${this.tenantId}/auth/${global.formatLongDate()}.xlsm`
                return await Storage.put(this.updateCsvPath, this.$refs.file.files[0]);
            } else {
                this.updateCsvPath = `${this.tenantId}/auth/${global.formatLongDate()}.csv`
                return await Storage.put(this.updateCsvPath, csvStr, {
                    contentType: "text/csv",
                });
            }
          
        },
        addSubscription() {
            console.log("subscription");
            this.subscription = API.graphql(graphqlOperation(onUpdateProcessJob)).subscribe({
                next: (eventData) => {
                    clearInterval(this.uploadCSVTimer)
                    if (eventData !== undefined && eventData.value !== undefined && eventData.value.data.onUpdateProcessJob !== null &&
                        eventData.value.data.onUpdateProcessJob.jobKey.includes(this.updateCsvPath) && 
                        eventData.value.data.onUpdateProcessJob.status > 0) {
                        this.listUser()
                        this.csvUploadMessage = this.$t("csv_upload_success")
                    } else {
                        this.csvUploadMessage = this.$t("csv_upload_error")

                    }
                },
            });
        },
    }
}
</script>
